import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { id: "app" }
const _hoisted_2 = { class: "body-container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "footer" }, [
  /*#__PURE__*/_createTextVNode(" Craft by Anonymous Traveler Studio "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "http://beian.miit.gov.cn",
    class: "beian"
  }, "沪ICP备17020691号-1")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MenuBar = _resolveComponent("MenuBar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_ElConfigProvider = _resolveComponent("ElConfigProvider")!
  const _directive_wechat_title = _resolveDirective("wechat-title")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ElConfigProvider, { locale: _ctx.locale }, {
      default: _withCtx(() => [
        _createVNode(_component_MenuBar),
        _createElementVNode("div", _hoisted_2, [
          _withDirectives((_openBlock(), _createElementBlock("div", null, [
            _createVNode(_component_router_view)
          ])), [
            [_directive_wechat_title, _ctx.route.meta.title]
          ])
        ]),
        _hoisted_3
      ]),
      _: 1
    }, 8, ["locale"])
  ]))
}